import React, { useState, useEffect } from 'react';
import { convertToLocaleTimeSS } from '../../../utils/timeConversion';
import axios from 'axios';
import { config } from '../../../utils/config';
import { NumericFormat } from 'react-number-format';

export default function BiddingHistory(props) {

  const [bidRecord, setbidRecord] = useState([])


  useEffect(() => {

    const getBidHistory = async () => {

      const response = await axios.get(`${config.apiBaseUrl}/bidsession/record`, {
        params: {
          bidId: props.id
        }
      })
      console.log("bid record", response.data)
      setbidRecord(response.data)

    }

    getBidHistory()



  }, [props])

  return (
    <>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Bidder</th>
              <th scope="col">Price</th>
              <th scope="col">Time</th>
            </tr>
          </thead>
          <tbody>
            {bidRecord.map((obj, index) => {
              return (
                <tr key={obj.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{'XXXXX' + obj.clients.nric.substring(5)}</td>
                  <td> <NumericFormat className="card-text" prefix={"$"} suffix={""} thousandSeparator={true} value={obj.bid_price} displayType={"text"} /></td>
                  <td>{convertToLocaleTimeSS(obj.created_at)}</td>
                </tr>
              )
            })}

          </tbody>
        </table>
      </div>

    </>
  )
}
